var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    { attrs: { title: _vm.id === null ? "Cadastrar Grupo" : "Editar Grupo" } },
    [
      _c(
        "vs-tabs",
        { attrs: { color: _vm.colorx } },
        [
          _c("vs-tab", { attrs: { label: "Grupo" } }, [
            _c("div", { staticClass: "vx-row mb-6" }, [
              _c(
                "div",
                { staticClass: "vx-col w-1/2" },
                [
                  _c("vs-input", {
                    staticClass: "w-full",
                    attrs: { label: "Nome de Exibição" },
                    model: {
                      value: _vm.display_name,
                      callback: function ($$v) {
                        _vm.display_name = $$v
                      },
                      expression: "display_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "vx-col w-1/2" },
                [
                  _c("vs-input", {
                    staticClass: "w-full",
                    attrs: { label: "Nome Interno" },
                    model: {
                      value: _vm.name,
                      callback: function ($$v) {
                        _vm.name = $$v
                      },
                      expression: "name",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "vx-row mb-6" }, [
              _c(
                "div",
                { staticClass: "vx-col w-full" },
                [
                  _c("vs-input", {
                    staticClass: "w-full",
                    attrs: { label: "Descrição" },
                    model: {
                      value: _vm.description,
                      callback: function ($$v) {
                        _vm.description = $$v
                      },
                      expression: "description",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "flex justify-end" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "float-right mr-2",
                    attrs: { variant: "primary" },
                    on: { click: _vm.create },
                  },
                  [
                    _c("span", { staticClass: "align-middle" }, [
                      _vm._v(_vm._s(_vm.$t("save"))),
                    ]),
                  ]
                ),
                _c(
                  "b-button",
                  {
                    staticClass: "float-right",
                    attrs: { variant: "outline-secondary" },
                    on: { click: _vm.goBack },
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-50",
                      attrs: { icon: "CornerUpLeftIcon" },
                    }),
                    _c("span", { staticClass: "align-middle" }, [
                      _vm._v(_vm._s(_vm.$t("back"))),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm.id !== null
            ? _c(
                "vs-tab",
                { attrs: { label: _vm.$t("functionality.titles") } },
                [
                  _c(
                    "app-collapse",
                    { attrs: { accordion: "true" } },
                    _vm._l(_vm.functionalityList, function (func) {
                      return _c(
                        "app-collapse-item",
                        { key: func.id, attrs: { title: func.name } },
                        [
                          _c(
                            "vs-table",
                            {
                              key: _vm.id,
                              attrs: { "no-data": " ", data: func.permissions },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var data = ref.data
                                      return _vm._l(data, function (tr, i) {
                                        return _c(
                                          "vs-tr",
                                          { key: i },
                                          [
                                            _c(
                                              "vs-td",
                                              { attrs: { data: data[i].id } },
                                              [
                                                _c("b-form-checkbox", {
                                                  attrs: {
                                                    id:
                                                      "permission_id_" +
                                                      data[i].id,
                                                    "vs-value": data[i].id,
                                                    checked: data[i].checked,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.selectPermission(
                                                        $event,
                                                        func.id,
                                                        data[i].id
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "vs-td",
                                              { attrs: { data: data[i].id } },
                                              [
                                                _c("label", [
                                                  _vm._v(_vm._s(data[i].id)),
                                                ]),
                                              ]
                                            ),
                                            _c(
                                              "vs-td",
                                              { attrs: { data: data[i].name } },
                                              [
                                                _c("label", [
                                                  _vm._v(_vm._s(data[i].name)),
                                                ]),
                                              ]
                                            ),
                                            _c(
                                              "vs-td",
                                              {
                                                attrs: {
                                                  data: data[i].display_name,
                                                },
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s(data[i].display_name)
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c(
                                              "vs-td",
                                              {
                                                attrs: {
                                                  data: data[i].description,
                                                },
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s(data[i].description)
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      })
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c(
                                "template",
                                { slot: "thead" },
                                [
                                  _c(
                                    "vs-th",
                                    { attrs: { width: "3%" } },
                                    [
                                      _c("b-form-checkbox", {
                                        attrs: { id: "func_id_" + func.id },
                                        on: {
                                          change: function ($event) {
                                            return _vm.selectPermissionsAll(
                                              $event,
                                              func.id,
                                              func.permissions
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("vs-th", { attrs: { width: "5%" } }, [
                                    _vm._v(_vm._s(_vm.$t("id"))),
                                  ]),
                                  _c("vs-th", { attrs: { width: "25%" } }, [
                                    _vm._v(_vm._s(_vm.$t("name"))),
                                  ]),
                                  _c("vs-th", { attrs: { width: "20%" } }, [
                                    _vm._v(_vm._s(_vm.$t("permissions_name"))),
                                  ]),
                                  _c("vs-th", { attrs: { width: "50%" } }, [
                                    _vm._v(_vm._s(_vm.$t("description"))),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _c("div", { staticClass: "vx-row mt-3" }, [
                    _c(
                      "div",
                      { staticClass: "vx-col w-full" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "float-right",
                            attrs: { variant: "outline-secondary" },
                            on: { click: _vm.goBack },
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "CornerUpLeftIcon" },
                            }),
                            _c("span", { staticClass: "align-middle" }, [
                              _vm._v(_vm._s(_vm.$t("back"))),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.id !== null
            ? _c("vs-tab", { attrs: { label: "Permissões" } }, [
                _c(
                  "div",
                  {
                    staticClass: "vx-row mb-6",
                    staticStyle: { "padding-top": "30px" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "vx-col w-full" },
                      [
                        _c(
                          "div",
                          { staticClass: "flex justify-end" },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "ripple",
                                    rawName: "v-ripple.400",
                                    value: "rgba(255, 255, 255, 0.15)",
                                    expression: "'rgba(255, 255, 255, 0.15)'",
                                    modifiers: { 400: true },
                                  },
                                ],
                                staticClass: "mr-2",
                                attrs: { variant: "primary" },
                                on: {
                                  click: function ($event) {
                                    _vm.showModal = true
                                  },
                                },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "PlusIcon" },
                                }),
                                _c("span", { staticClass: "align-middle" }, [
                                  _vm._v(_vm._s(_vm.$t("add"))),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "b-button",
                              {
                                staticClass: "float-right",
                                attrs: { variant: "outline-secondary" },
                                on: { click: _vm.goBack },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "CornerUpLeftIcon" },
                                }),
                                _c("span", { staticClass: "align-middle" }, [
                                  _vm._v(_vm._s(_vm.$t("back"))),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("vs-divider"),
                        _c("Grid", {
                          key: _vm.gridKey,
                          ref: "grid",
                          attrs: {
                            service: _vm.permissionService,
                            route_name: "permissions",
                            route_grid_path: _vm.permissionsRolePath,
                            route_delete_path: _vm.permissionsRolePath,
                            order_column: "name",
                            hide_edit: "true",
                            multipleSelect: true,
                            delegate: {
                              destroy: function () {
                                return _vm.destroyPermissionRole
                              },
                            },
                          },
                          on: { changedSelection: _vm.changedSelection },
                        }),
                        _c("div", { staticClass: "vx-row mr-2" }, [
                          _c(
                            "div",
                            { staticClass: "vx-col w-full" },
                            [
                              _vm.enableActionDeletePermissions
                                ? _c(
                                    "b-button",
                                    {
                                      staticClass: "float-right",
                                      attrs: { variant: "primary" },
                                      on: {
                                        click: _vm.confirmDeletePermissions,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("action.delete")) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "vs-popup",
        {
          attrs: { title: "Permissões", active: _vm.showModal },
          on: {
            "update:active": function ($event) {
              _vm.showModal = $event
            },
          },
        },
        [
          _vm.showModal
            ? _c("Grid", {
                attrs: {
                  multipleSelect: true,
                  service: _vm.permissionService,
                  route_name: "permissions",
                  hide_actions: "true",
                },
                on: { changedSelection: _vm.changedSelection },
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "flex justify-end" },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "ripple",
                      rawName: "v-ripple.400",
                      value: "rgba(255, 255, 255, 0.15)",
                      expression: "'rgba(255, 255, 255, 0.15)'",
                      modifiers: { 400: true },
                    },
                  ],
                  attrs: { variant: "primary" },
                  on: { click: _vm.addPermissions },
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "PlusIcon" },
                  }),
                  _c("span", { staticClass: "align-middle" }, [
                    _vm._v(_vm._s(_vm.$t("add"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }